import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectMenuOption } from "../../../../form/select-menu/select-menu.component";
import { EventsService } from "../../../../_services/eventsServices/events.service";

import { Router } from "@angular/router";
import { trimTextByWord } from "../../../events-screen/utils/trimTextByWord";
import {
  FamilyMemberModel,
  FamilyModel,
} from "../../brother-attribution-models/family-model";
import { TranslationService } from "../../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../../_models/ITranslations";
import { GeneralRowEvent } from "../../../../_models/general-row-event";
import { AuthenticationService } from "../../../../_services/authentication.service";
import { DataService } from "../../../../_services/data.service";

@Component({
  selector: "brother-attribution-request-row",
  templateUrl: "./brother-attribution-request-row.component.html",
  styleUrls: ["./brother-attribution-request-row.component.scss"],
  animations: [
    trigger("openClose", [
      state(
        "open",
        style({
          maxHeight: "1500px",
          opacity: 1,
          overflow: "visible",
        })
      ),
      state(
        "closed",
        style({
          maxHeight: "1px",
          height: "1px",
          opacity: 0,
          overflow: "hidden",
        })
      ),
      transition("open => closed", [animate("0.2s")]),
      transition("* => open", [animate("0.2s")]),
      transition("closed => open", [animate("0.2s")]),
    ]),
  ],
})
export class BrotherAttributionRequestRow implements OnInit, OnDestroy {
  @Output("rowEvent") public rowEvent: EventEmitter<
    GeneralRowEvent<FamilyModel>
  > = new EventEmitter<GeneralRowEvent<FamilyModel>>();

  @Input() public family: FamilyModel;
  public familyMembers: FamilyMemberModel[];
  public openToExtendedText: string = "";

  public eventStatusMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "open",
      text: "פתוח",
      customValue: "",
    },
    {
      icon: "",
      key: "closed",
      text: "סגור",
      customValue: "",
    },
  ];
  public parentEventStatus: SelectMenuOption = this.eventStatusMenuOptions[0];
  public translations$: Observable<ITranslations>;
  protected readonly transition = transition;

  constructor(
    private eventService: EventsService,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {
    this.familyMembers = this.family.members;
  }

  ngOnDestroy(): void {}

  public editChildClicked(action: "approve" | "delete"): void {
    this.rowEvent.emit({
      action,
      eventId: "0",
      eventObject: this.family,
    });
  }

  public trimText(text: string, maxlength = 14) {
    return trimTextByWord(text, maxlength);
  }
  public first9chars(text: string = "") {
    return (text || "").substring(0, 9);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-search-results/brother-attribution-request-row/brother-attribution-request-row.component.ts